import React from 'react';
import { useScrollSpyContext } from './ScrollSpypContext';

interface IScrollSpyProps {
  activeClassName?: string;
  render?: (e?: any) => React.ReactNode;
}

const ScrollSpy: React.FC<React.PropsWithChildren<IScrollSpyProps>> = ({ render }) => {
  const { activeSection } = useScrollSpyContext();

  return <>{render?.(activeSection) || null}</>;
};
export default ScrollSpy;
